import React, { useState, useCallback, useContext, useEffect, useMemo } from 'react'
import { Box, TextField, Button, Grid, Autocomplete, Select, MenuItem, InputLabel, FormControl, Typography,
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import { getVendorBankDetails, savePayouts } from 'services/payouts';
import { AppContext } from 'core/context/';
import { getPropertiesByOwner } from 'services/libraries';

const AddPayment = ({ pageFilters, onSuccess, onFailure }) => {

  const defaultFormFields = useMemo(() => ({
    propertyId: '',
    userId: '',
    // description: '',
    method: '',
    referenceNumber: '',
    amount: '',
  }),[]);

  const [libraries, setLibraries] = useState([]);
  const [bankDetails, setBankDetails] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const { vendors } = useContext(AppContext);
  const { handleSubmit, control, formState: { errors }, reset, watch, setValue } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  // useEffect(() => {
  //   if(pageFilters?.library?.libraryId){
  //     setValue('propertyId', pageFilters.library.name)
  //   }

  //   if(pageFilters?.vendor?.userId){
  //     setValue('userId', pageFilters.vendor )
  //   }
   
  // }, [pageFilters, setValue]);
  
  const getVendorLibraries = useCallback((ownerId) => {
    getPropertiesByOwner({ownerId}).then(({response, error}) => {
      if(response){
        setLibraries([...(response || [])]);
      } else {
        setLibraries([]);
      }
    });
  },[]);
  
  const userId = watch('userId');
  useEffect(() => {
    if(userId){
      setLibraries([]);
      setValue('propertyId', '');
      setTimeout(()=>getVendorLibraries(userId.userId),100);
      
    }else{
      setValue('propertyId', '');
      setLibraries([]);
    }
  }, [userId, setValue, getVendorLibraries])

  const resetForm = () => {
    reset({...defaultFormFields});
  };

  const onSubmit = (data) => {
    if(!bankDetails){
      enqueueSnackbar("No bank details added to vendor", {variant: 'error'});
      return;
    }
    saveUserDetails(data);
  }

  const saveUserDetails = (data) => {
    const postData ={
      propertyId: data.propertyId.id,
      userId: data.userId.userId,
      description: data.description,
      referenceNumber: data.referenceNumber,
      method: data.method,
      bankName: bankDetails.bankName,
      ifsc: bankDetails.ifsc,
      accountNumber: bankDetails.accountNumber,
      amount: Number(data.amount)
    };
    savePayouts({
      ...postData,
    }).then(({response, error}) => {
      if(response){
        enqueueSnackbar((`Payment successful`), {variant: 'success'});
        resetForm();
        onSuccess()
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      }
    });
  }

  const filterOptions = useCallback((options, { inputValue }) => {
    if(inputValue){
      return options.filter((option) => option?.displayName?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) || option?.mobile?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()));
    }
    return options;
  }, []);

  const getVendorBankInfo = useCallback((propertyId, vendorId) => {
    getVendorBankDetails({propertyId, vendorId}).then(({response, error}) => {
      if(response){
        setBankDetails(response);
      } else {
        setBankDetails(null);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);

  const selectedUserId = watch('userId')?.userId;
  const selectedPropertyId = watch('propertyId')?.id;
  useEffect(() => {
   if(selectedUserId && selectedPropertyId){
    const propertyId =  selectedPropertyId;
    const userId =  selectedUserId;
    getVendorBankInfo(propertyId, userId);
   }else{
    setBankDetails(null)
   }
  }, [getVendorBankInfo, selectedUserId, selectedPropertyId]);
  

  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={2} justifyContent="center">
 
        <Grid  item xs={12} sm={11} md={10} lg={10} sx={{mt: 2}}>
          <Controller
            control={control}
            name="userId"
            id="userId"
            rules={{ required: "Select Vendor" }}
            render={({field}) => (
              <Autocomplete
                {...field}
                options={vendors}
                size="small"
                name="userId"
                fullWidth
                filterOptions={filterOptions} 
                getOptionLabel={(option) => option?.displayName || option }
                isOptionEqualToValue={(option, value) => (option?.userId === value?.userId)}
                onChange={(event, newValue) => {
                  field.onChange(newValue);
                }}
                renderOption={(props, option) => <li {...props} key={option.userId}>{option.displayName}</li>}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    {...field} 
                    error={!!errors?.userId}  
                    required 
                    fullWidth
                    label="Vendor"
                    InputProps={{
                      ...field,
                      ...params.InputProps,
                      // startAdornment: 
                      //   <InputAdornment position="start">
                      //     <IconButton
                      //       aria-label="Vendor Name"
                      //       edge="end"
                      //     >
                      //       <PersonIcon />
                      //     </IconButton>
                      //   </InputAdornment>
                    }}
                  />
                )}
              />
            )}
            onChange={([, data]) => data}
          />
        </Grid>

        <Grid  item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="propertyId"
            id="propertyId"
            rules={{ required: "Select property" }}
            render={({field}) => (
              <FormControl {...field} required fullWidth error={!!errors?.propertyId}>
                <InputLabel id="property-input-label" size="small">Property</InputLabel>
                <Select
                  label="Property"
                  name="propertyId"
                  required
                  size="small"
                  value={field?.value?.name}
                  onChange={field.onChange}
                >
                   {libraries.map((library, index) => <MenuItem key={index} value={library}>{library.name}</MenuItem>)}
                </Select>
              </FormControl>
            )}
          />
        </Grid>

        {bankDetails ? (
          <Grid item xs={12} sm={11} md={10} lg={10} sx={{mb: 1}}>
            <Box sx={{background: '#d1e3dc', p: 2, borderRadius: '6px'}} >
              <Typography variant="h6" component="p" sx={{color: '#3c7b62', mb: .5}}>Account Details</Typography>
              <Typography variant="subtitle2" component="p">{bankDetails?.bankName}</Typography>
              <Typography variant="subtitle2" component="p">{bankDetails?.accountNumber}</Typography>
              <Typography variant="subtitle2" component="p">{bankDetails?.ifsc}</Typography>
            </Box>
          </Grid>
        ) : null}

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="method"
            id="method"
            rules={{ required: "Enter payment Method"}}
            render={({field}) => (
              <FormControl fullWidth  {...field} error={!!errors?.method}>
                <InputLabel required id="payment-method-select-label" size="small">Pament Method</InputLabel>
                <Select
                  required
                  size="small"
                  labelId="payment-method-select-label"
                  id="payment-method-select"
                  label="Pament Method"
                  value={field?.value}
                  onChange={field.onChange}
                  fullWidth
                >
                  <MenuItem value="NEFT">NEFT</MenuItem>
                  <MenuItem value="IMPS">IMPS</MenuItem>
                  <MenuItem value="RTGS">RTGS</MenuItem>
                </Select>
              </FormControl>
            )}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="referenceNumber"
            id="referenceNumber"
            rules={{ required: "Enter reference number"}}
            render={({field}) => (
              <TextField
                {...field}
                label="Reference Number"
                required
                error={!!errors?.referenceNumber}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="amount"
            id="amount"
            rules={{ required: "Enter amount",pattern: {value: /^[1-9]\d*(\d+)?$/i,message: 'Please valid amount'}}}
            render={({field}) => (
              <TextField
                {...field}
                label="Amount"
                required
                error={!!errors?.amount}
                size="small"
                fullWidth
                type="string"
              />
            )}
          />
        </Grid>
{/* 
        <Grid item xs={12} sm={11} md={10} lg={10}>
          <Controller
            control={control}
            name="description"
            id="description"
            rules={{ required: "Enter description"}}
          render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Description"
                required
                error={!!errors?.description}
                size="small"
                fullWidth
                multiline
                minRows={5}
              />
            )}
          />
        </Grid> */}
          
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: 'inherit' }}
            startIcon={<AddIcon />}
            color="primary"
          >
            Add
          </Button>
        </Grid>


        </Grid>
    </Box>
  );
}
 
export default React.memo(AddPayment);
